// TODO@deprecated
import { formatForServer } from '@/utils/date'
import { then } from '@/utils/immutable'

import { types } from '@/models/tasks'

export const filterToFilterForServer = (x, { type, deprecated = false } = {}) => {
  const filter = { ...x }

  const deprecatedKeys = {
    initiatorUserId: 'creator.id',
    initiatorOrganizationId: 'creator_organization_id',
    inspectorUserId: 'defectGeneralContractor.id',
    inspectorOrganizationId: 'defect_general_contractor_organization_id',
    workerUserId: 'memberWorkers.user.id',
    workerOrganizationId: 'worker_organization_id',
    acceptanceContractorUserId: 'acceptanceOfWorkContractor.id',
    acceptanceContractorOrganizationId: 'acceptance_work_contractor_organization_id',
    buildingOrderName: 'objectsBuildingOrderConnection.object.name'
  }

  const keys = deprecated ? deprecatedKeys : {
    initiatorUserId: 'initiator_user_id',
    initiatorOrganizationId: 'initiator_organization_id',
    inspectorUserId: 'inspector_user_id',
    inspectorOrganizationId: 'inspector_organization_id',
    workerUserId: 'worker_user_id',
    workerOrganizationId: 'worker_organization_id',
    acceptanceContractorUserId: 'acceptance_work_contractor_user_id',
    acceptanceContractorOrganizationId: 'acceptance_work_contractor_organization_id',
    buildingOrderName: 'connected_building_order_task_name'
  }

  filter.creator && (filter[keys.initiatorUserId] = filter.creator.id)
  filter.creatorOrganization && (filter[keys.initiatorOrganizationId] = filter.creatorOrganization.id)

  filter.creator = null
  filter.creatorOrganization = null

  is({
    [types.DEFECTS_AND_VIOLATIONS]: () => {
      filter.worker && (filter[keys.workerUserId] = filter.worker.id)
      filter.workerOrganization && (filter[keys.workerOrganizationId] = filter.workerOrganization.id)

      filter.worker = null
      filter.workerOrganization = null

      filter.inspector && (filter[keys.inspectorUserId] = filter.inspector.id)
      filter.inspectorOrganization && (filter[keys.inspectorOrganizationId] = filter.inspectorOrganization.id)

      filter.inspector = null
      filter.inspectorOrganization = null

      filter[keys.buildingOrderName] = filter.buildingOrderName
          
      filter.buildingOrderName = null
    },
    [types.ACCEPTANCE_OF_WORK]: () => {
      filter.contractor && (filter[keys.acceptanceContractorUserId] = filter.contractor.id)
      filter.contractorOrganization && (filter[keys.acceptanceContractorOrganizationId] = filter.contractorOrganization.id)

      filter.contractor = null
      filter.contractorOrganization = null

      filter.worker && (filter[keys.workerUserId] = filter.worker.id)
      filter.workerOrganization && (filter[keys.workerOrganizationId] = filter.workerOrganization.id)

      filter.worker = null
      filter.workerOrganization = null
    },
    [types.BUILDING_ORDER]: () => {
      filter.worker && (filter[keys.workerUserId] = filter.worker.id)
      filter.workerOrganization && (filter[keys.workerOrganizationId] = filter.workerOrganization.id)

      filter.worker = null
      filter.workerOrganization = null
    },
    [types.PHOTO_ORDER]: () => {
      filter.inspector && (filter[keys.initiatorUserId] = filter.inspector.id)
      filter.inspectorOrganization && (filter[keys.inspectorOrganizationId] = filter.inspectorOrganization.id)

      filter.inspector = null
      filter.inspectorOrganization = null
    }
  })[type]?.()

  filter.expired_from && (filter.expired_from = formatForServer(filter.expired_from))
  filter.expired_to && (filter.expired_to = formatForServer(filter.expired_to))
  filter.created_from && (filter.created_from =  formatForServer(filter.created_from))
  filter.created_to && (filter.created_to = formatForServer(filter.created_to))
  filter.started_from && (filter.started_from =  formatForServer(filter.started_from))
  filter.started_to && (filter.started_to = formatForServer(filter.started_to))

  filter.place?.house && !filter.place?.floor && (filter.house = filter.place.house.id)
  filter.place?.floor && (filter.floor = filter.place.floor.id)

  then(filter.is_izm, ({ value }) => filter.is_izm = value)

  filter.place = null

  const result = Object.entries(filter).reduce((r, [k, v]) => ({
    ...r,
    ...v && { [k]: v }
  }), {})

  return result
} 
